import { BagDto } from '@features/ManualSorting/model/manualSorting';
import { PageList } from '@shared/types/filter';

export enum ShipmentStatus {
  Created = 'Created',
  Completed = 'Completed',
}

export type GetAllShipmentsHttpResponse = PageList<ShipmentDto>;

export interface ShipmentDto {
  id: number;
  assingBagsCount: number;
  number: string;
  status: ShipmentStatus;
  vehicleNumber: string;
  bags: BagDto[];
  isReturn: boolean;
}

export interface GetShipmentHttpResponse {
  id: number;
  number: string;
  status: ShipmentStatus;
  assingBagsCount: number;
  bags: BagDto[];
  isReturn: boolean;
}

export interface CreateShipmentHttpRequest {
  vehicleNumber: string;
  isReturn: boolean;
  nextDropOffPointId: string;
}

export interface DropOffPointDto {
  id: string;
  name: string;
  isReturn: boolean;
}

export interface GetDropOffPointsHttpResponse {
  items: DropOffPointDto[];
}

export interface AddBagToShipmentManifestHttpRequest {
  shipmentId: number;
  bagNumber: string;
}

export interface AddBagToShipmentHttpResponse {
  status: AddBagToShipmentStatus;
  bags: BagDto[];
}

export enum AddBagToShipmentStatus {
  InternalError,
  Added,
  NotFound,
  ShipmentNotFound,
  AlreadyAddedToAnotherShipment,
  PostalBagWasNotLabeled,
  // Новые значения добавлять только в конец: статус приходит числом, сдвиг сломает трактовку
  ShipmentCompleted,
  ReturnBagRequiresReturnShipment = 7,
  ReturnShipmentRequiresReturnBag = 8,
}

export interface RemoveBagFromShipmentHttpResponse {
  status: RemoveBagFromShipmentStatus;
  bags: BagDto[];
}

export enum RemoveBagFromShipmentStatus {
  Removed,
  ShipmentNotFound,
  BagNotFound,
  ShipmentAlreadyCompleted,
}

export interface CompleteShipmentHttpRequest {
  shipmentId: number;
}

export interface CompleteShipmentHttpResponse {
  status: CompleteShipmentStatus;
}

export enum CompleteShipmentStatus {
  InternalError,
  Completed,
  ShipmentNotFound,
  AlreadyCompleted,
  NoBagsInShipment,
}
